const containerSelector = '[data-wps-product-categories-menu-mobile]';

document.querySelectorAll(containerSelector).forEach((container) => {
	if (!(container instanceof HTMLElement)) {
		return;
	}

	const trigger = container.querySelector('[data-wps-product-categories-menu-trigger]');
	const dropdown = container.querySelector('[data-wps-product-categories-menu-dropdown]');
	const links = container.querySelectorAll('[data-wps-product-categories-menu-item]');

	if (!(trigger instanceof HTMLButtonElement) || !(dropdown instanceof HTMLElement)) {
		return;
	}

	const closeDropdown = () => {
		container.classList.remove('is-open');
		dropdown.hidden = true;
		trigger.setAttribute('aria-expanded', 'false');
	};

	const openDropdown = () => {
		container.classList.add('is-open');
		dropdown.hidden = false;
		trigger.setAttribute('aria-expanded', 'true');
	};

	trigger.addEventListener('click', () => {
		if (container.classList.contains('is-open')) {
			closeDropdown();
			return;
		}
		openDropdown();
	});

	document.addEventListener('click', (event) => {
		if (!(event.target instanceof Node)) {
			return;
		}
		if (!container.contains(event.target)) {
			closeDropdown();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			closeDropdown();
		}
	});

	links.forEach((link) => {
		if (!(link instanceof HTMLAnchorElement)) {
			return;
		}
		link.addEventListener('click', () => {
			closeDropdown();
		});
	});
});
